module.exports = __webpack_public_path__ + "static/media/dots1.6a422ebb.svg";